import jsPDF from 'jspdf';
import 'jspdf-autotable';

const ExportToPdf = (jsonData, fileName ) => {  
    if (!jsonData || !Array.isArray(jsonData) || jsonData.length === 0) {      
      return false;
    }

    const doc = new jsPDF('landscape');

    // Define column headers for the table (keys from JSON data)
    const columns = Object.keys(jsonData[0]);

    // Map JSON data to table rows
    const rows = jsonData.map((item) => columns.map((key) => item[key]));

   // Add title to the PDF
   doc.text(`${fileName} Report`, 5, 10);

   doc.autoTable({
    head: [columns],
    body: rows,
    startY: 12,
    styles: {
      fontSize: 5, // Adjust font size to fit more data
      cellWidth: 8, // This will distribute widths based on the content
    },
    theme: 'striped',
    headStyles: { fillColor: '#1F8C61'},
    margin: { top: 20 },  // Adjust margin to avoid overlapping title
  });



    // Save the PDF
    doc.save(`${fileName}.pdf`);

  return true
};

export default ExportToPdf;
